import React from "react";
import "./PostMobile.css";

import { CommentIcon, ShareIcon, SaveIcon, KebabIcon } from "./icons";
import StarRatingV2 from "./components/StarRatingV2/StarRatingV2";
import RichCaption from "./components/RichCaption";
import PostCarousel from "./components/PostCarousel";
import FeedVideo from "./components/FeedVideo";
import { resolveVideoUrl } from "./utils/videoSource";
import PostImage from "./components/PostImage";
import { usePostLogic, kisaltAciklama } from "./hooks/usePostLogic";
import ShareSheet from "./components/ShareSheet";
import ReportModal, { SikayetHedefi } from "./components/ReportModal";
import { REPORT_TARGET_TYPE } from "./constants/reportSchema";
import { useCachedMyRating } from "./utils/myRatingsCache";
import { formatTimeAgoShort, formatCount } from "./utils";
// Makine-okunur zaman TEK otoriteden. Eski gövde nesneyi metne çeviriyor ve
// `<time>`a nesne-metnini basıyordu (gerekçe: gonderiZamanDamgasi.ts başlığı).
import { damgaAttr, baslikAttr } from "./gonderiZamanDamgasi";
// #888 — bayat göreli zaman: TEK paylaşılan tik (kart başına setInterval YOK).
import { useGoreliZamanTiki } from "./hooks/useGoreliZamanTiki";
import { IkonKoprusu } from "./icon-system/runtime/IkonKoprusu";
import PostActionsBar from "./components/PostActionsBar/PostActionsBar";
import PostRatingSummary from "./components/PostRatingSummary/PostRatingSummary";

const FeedVideoAny = FeedVideo as any;

/* İkon satır kutusu — KULLANIM_SOZLESMESI §4 ORTAK ÇÖZÜM: kip/kutu/hiza garantisi
   `IkonKoprusu satirIci` → `IconFrame` (inline-block · --ikon-kullanim-metin ·
   --ikon-metin-hiza); çağrı-yeri yaması söküldü. */

/* ── EYLEM RAYI OPTİK DENGESİ — `content.share` (2026-09-12, ÖLÇÜLDÜ) ───────
   Owner: *"Aynı width/height değerini vermeyi denge sayma. Görünen şeklin
   ALANINI, kenar boşluklarını, hizasını ve dolu/çizgili ağırlığını birlikte
   değerlendir. Dokunma alanını korurken çizimin görünen boyutunu ayarla."*

   ÖLÇÜM YÖNTEMİ (kutu değil, ÇİZİMİN KENDİSİ): her rayın `<svg>`si gerçek
   ekrandan klonlanıp aynı ölçekte (24 birim → 192 px) canvas'a boyandı ve
   alfa>32 olan piksel SAYILDI. `getBBox()` KULLANILMADI — o konturu saymaz,
   oysa mürekkebin yarısı konturdur (`stroke-width:2`).

   AKIŞ RAYI · bayrak AÇIK · mürekkep sınır kutusu (svg birimi = 24 px kutuda px):
       rating.star     outline   20,75 × 20,13 · mürekkep %23,17 · boşluk 1,63/1,63
       content.comment outline   22,00 × 21,00 · mürekkep %22,73 · boşluk 1,00/1,00
       content.share   outline   22,50 × 23,00 · mürekkep %26,55 · boşluk 0,50/1,00
       content.save    outline   14,00 × 20,00 · mürekkep %20,83 · boşluk 5,00/5,00
   → `content.share` RAYIN AYKIRISI: çizimi kutusunun %95,8'ini dolduruyor
     (komşular %83,3–%87,5) ve mürekkeği komşu ortalamasının **%15,7** üstünde.
     Aynı 24 px kutuda "daha büyük" okunuyor.
     ⚠️ BU BİR GEOMETRİ KUSURU DEĞİLDİR: çizim viewBox'ını kasten doldurur
     (üç düğüm r=3, y=4,5 ve y=19,5 + kontur 2 → mürekkep y 0,5..23,5) ve
     onaylı hâlidir. Dengesizlik GEOMETRİDEN değil UYGULAMADAN doğuyor:
     viewBox'ını komşularından daha çok dolduran bir çizime komşularıyla AYNI
     kutu veriliyor. Bu turun konusu tam olarak bu — `path` verisine ve
     `stroke=2` sözleşmesine DOKUNULMADI, yalnız kutu ölçüldü ve düzeltildi.

   ONARIM: yalnız GÖRÜNEN kutu 24 → 22 px (`1.375rem`). Ölçülen sonuç
   (mürekkep sınırı ölçekle çarpılarak): share 23,00 → **21,08** px yükseklik,
   22,50 → 20,63 genişlik. Rayın mürekkep-yükseklik yayılımı
       ÖNCE  20,00 … 23,00 = 3,00 px
       SONRA 20,00 … 21,08 = 1,08 px   (−%64)
   ── 🔴 GERİ ALINDI (2026-09-12) — OWNER KARARI ──────────────────────────
   `docs/ikon/KULLANIM_SOZLESMESI.md` §0.3 bu küçültmeyi AJAN TERCİHİ olarak
   sınıflıyor ve *"geri alınacak"* diyor; owner birebir: *"mürekkep miktarını
   eşitlemek için ikonları bozma."* §2.2: *"Bir ikonun dar olması kusur
   değildir … kutular hizalıdır, mürekkep değil."* §2.1: aksiyon kategorisi
   **24 px**tir; 22 px o dört ölçünün dışında bir istisnaydı.
   Yani yukarıdaki ölçüm YANLIŞ DEĞİLDİ — ölçtüğü şey (mürekkep) bir KABUL
   ÖLÇÜTÜ değildi. `content.share` artık komşularıyla aynı `boyut="md"` (24)
   kutusunda çizilir; bu nesne yalnız tarih olarak duruyor, KULLANILMIYOR.
   🧭 Kanon dersi: bir vekil ölçütü (mürekkep alanı) iyileştirmek, tasarımın
   kabul edildiğini göstermez — `DIL_V2.md` §1 bunu zaten yazıyordu. */

/** Mobil ana akış gönderi kartı */
export default function PostMobile({ post, aktifKullaniciId, onUserClick, onCommentClick }: any) {
  // #888 — göreli zaman TEK paylaşılan tikle tazelenir (kart başına timer YOK).
  useGoreliZamanTiki();
  // PR-63 — cihaz-kalıcı kendi puanım (local map lookup + pub/sub; ağır iş yok).
  const myCachedRating = useCachedMyRating(aktifKullaniciId, post?.id);
  const {
    authorProfile,
    isSaved,
    optionsOpen,
    setOptionsOpen,
    isMediaLoaded,
    setIsMediaLoaded,
    menuRef,
    isOwner,
    handleDelete,
    handleToggleSave,
    handleShare,
    handleToggleComments,
    handleGoToPost,
    handleRate,
    editOpen,
    editText,
    setEditText,
    openEdit,
    cancelEdit,
    saveEdit,
    showBurst,
    handleMediaTap,
    rateOpenNonce,
    agg,
    // P1-1 — açıklama kısaltma durumu masaüstüyle PAYLAŞILAN state'ten gelir.
    showFullCaption,
    setShowFullCaption,
    // P1-4/P1-5 — paylaş sheet'i (kart ✈️ artık alert açmıyor).
    shareOpen,
    setShareOpen,
    permalink,
    shareAttachment,
  } = usePostLogic(post, aktifKullaniciId, onCommentClick);
  const [sikayetHedefi, setSikayetHedefi] = React.useState<SikayetHedefi | null>(null);

  if (!authorProfile) {
    return (
      <article className="pm-article skeleton" aria-busy="true">
        <header className="pm-header">
          <div className="skel-avatar" />
          <div className="skel-line w80" />
        </header>
        <div className="skel-media" />
      </article>
    );
  }

  const username = authorProfile?.kullaniciAdi || "kullanıcı";
  const avatarUrl = authorProfile?.profilFoto || "/avatars/default.svg";

  const mediaUrl = post?.mediaUrl || "";
  const isVideo = (post?.mediaType || "").startsWith("video");
  // Carousel: mediaItems varsa onu kullan; eski gönderiler tekil alanlardan gelir.
  const mediaItems = Array.isArray(post?.mediaItems) && post.mediaItems.length
    ? post.mediaItems
    : (mediaUrl ? [{ url: mediaUrl, type: isVideo ? "video" : "image" }] : []);

  // P1-1 (IG akış denetimi) — açıklama kısaltma. Masaüstü kart bunu 2026-06'dan
  // beri yapıyordu, mobil ikizi TAM METNİ basıyordu: uzun açıklamalı bir gönderi
  // ekranın yarısını kaplayıp altındaki kartı akıştan itiyordu. Eşik ve türetim
  // `usePostLogic`ten gelir — iki kartta iki ayrı kopya YOK (bkz. oradaki
  // `CAPTION_LIMIT` gerekçesi).
  const { needsClamp, preview: captionPreview, text: captionText } = kisaltAciklama(post?.mesaj);
  const yorumAdet = Array.isArray(post?.yorumlar) ? post.yorumlar.length : (post?.commentsCount || 0);
  const paylasAdet = post?.sharesCount || (Array.isArray(post?.paylasimlar) ? post.paylasimlar.length : 0);

  return (
    <article className="pm-article">
      <header className="pm-header">
        <button
          className="pm-user pressable"
          onClick={() => onUserClick?.(post.authorId)}
          aria-label={`${username} profilini aç`}
        >
          <img src={avatarUrl} alt="" className="pm-avatar" />
          <span className="pm-user-meta">
            <span className="pm-username">{username}</span>
            {/* ── BAŞLIK ALT SATIRI — konum + etiketli kişi AYNI SATIR KUTUSU ─
                ÖLÇÜLEN KUSUR (bu tur, gerçek akış ekranı): `.pm-user-meta`
                `flex-direction: column` → konum KENDİ satırını, "N kişi" AYRI
                bir satırını açıyordu; ikisi de olan bir gönderide başlık ÜÇ
                satırdı. Owner (§8): *"İsim, konum ve etiketlenen kişiler
                kompakt ve hizalı görünsün."*
                Bu sarmalayıcı ikisini TEK satıra alır; SIĞMAZSA sarar
                (`flex-wrap`) — KULLANIM_SOZLESMESI §4 kesmeyi/`nowrap`ı
                YASAKLIYOR: *"Uzun mekân/kullanıcı adı doğal sarmaya devam
                eder — `nowrap` ile kilitlenmez, font küçültülmez, metin
                kesilmez."* Bu yüzden burada ellipsis YOK; dayanıklılık
                taşmayı ÖNLEYEREK sağlanır (`min-width:0` + sarma).
                ⚠️ İkonun kendi satır kutusunu açmaması AYRI mesele ve
                §4 ortak çözümüyle (`IkonKoprusu satirIci` → `IconFrame`)
                ikon bileşeninde garanti altında. */}
            {(post?.konum || (Array.isArray(post?.taggedUids) && post.taggedUids.length > 0)) && (
              <span className="pm-user-sub">
                {/* `satirIci` — §4 ortak çözüm (ikon bileşeni garanti eder). KALDIRMA →
                    konum işareti mekân adının üstüne çıkar, başlık +16 px uzar. */}
                {post?.konum && <span className="pm-location" title="Konum"><IkonKoprusu aile="place.pin" boyut="xs" satirIci eski="📍" /> {post.konum}</span>}
                {Array.isArray(post?.taggedUids) && post.taggedUids.length > 0 && (
                  <span className="pm-location pm-tagged" title="Etiketlenenler">{/* ANLAM (§7): etiketlenen kişiler → `profile.tabTagged` (Post.tsx ikizi). */}<IkonKoprusu aile="profile.tabTagged" boyut="xs" satirIci eski="👤" /> {post.taggedUids.length} kişi</span>
                )}
              </span>
            )}
          </span>
        </button>

        <div className="pm-more" ref={menuRef}>
          {/* a11y (#973): axe `button-name` (CRITICAL) — ölçüldü, GÖZ turunun
              3 sahnesinde. Düğme SALT İKON (`<KebabIcon />`, metin yok) ve
              erişilebilir adı YOKTU → ekran okuyucu yalnız "düğme" diyordu.
              WCAG 2.5.3 (Label in Name) çakışması YOK: görünür metin
              bulunmadığı için `aria-label` uydurma değil, TEK addır. */}
          <button
            className="pm-kebab"
            onClick={() => setOptionsOpen((v) => !v)}
            aria-haspopup="menu"
            aria-expanded={!!optionsOpen}
            aria-label="Gönderi seçenekleri"
          >
            {/* FAZ C / DALGA 2 — elle: `KebabIcon` (varsayılan direction=vertical → action.moreVertical); ESLEME belirsiz saydığı için codemod sarmadı. */}
            <IkonKoprusu aile="action.moreVertical" eski={<KebabIcon />} />
          </button>

          {optionsOpen && (
            <div className="pm-menu" role="menu">
              <button className="pm-menu-item pressable" onClick={handleGoToPost} role="menuitem">Gönderiye git</button>
              {isOwner && (
                <button className="pm-menu-item pressable" onClick={openEdit} role="menuitem">Açıklamayı düzenle</button>
              )}
              {isOwner && (
                <button className="pm-menu-item pressable" onClick={handleToggleComments} role="menuitem">
                  {post?.yorumlarKapali ? "Yorumları aç" : "Yorumları kapat"}
                </button>
              )}
              {isOwner && (
                <button className="pm-menu-item danger pressable" onClick={handleDelete} role="menuitem">Sil</button>
              )}
              {!isOwner && (
                <button
                  className="pm-menu-item pressable"
                  onClick={() => {
                    setOptionsOpen(false);
                    setSikayetHedefi({ targetType: REPORT_TARGET_TYPE.POST, targetId: String(post?.id || "") });
                  }}
                  role="menuitem"
                >Şikayet et</button>
              )}
              <button className="pm-menu-item pressable" onClick={() => setOptionsOpen(false)} role="menuitem">Vazgeç</button>
            </div>
          )}
        </div>
      </header>

      <div className="pm-media">
        {!isMediaLoaded && <div className="skel-media" aria-hidden="true" />}
        {mediaItems.length > 1 ? (
          <PostCarousel
            items={mediaItems}
            altText={post?.altText}
            onMediaClick={handleMediaTap}
            onFirstLoad={() => setIsMediaLoaded(true)}
          />
        ) : mediaItems.length === 1 && (mediaItems[0].type === "video" ? (
            <FeedVideoAny
              className={`pm-media-el ${isMediaLoaded ? "loaded" : ""}`}
              /* PR-39 — R2/CDN-ready: cdnUrl varsa CDN, yoksa Firebase mediaUrl (bugün aynı). */
              src={resolveVideoUrl(post) || mediaItems[0].url}
              poster={mediaItems[0].poster}
              w={mediaItems[0].w}
              h={mediaItems[0].h}
              onCanPlay={() => setIsMediaLoaded(true)}
              onClick={handleMediaTap}
            />
          ) : (
            <PostImage
              className={`pm-media-el ${isMediaLoaded ? "loaded" : ""}`}
              src={mediaItems[0].url}
              alt={post?.altText || "Gönderi görseli"}
              w={mediaItems[0].w}
              h={mediaItems[0].h}
              onLoad={() => setIsMediaLoaded(true)}
              onClick={handleMediaTap}
            />
          ))}
        {showBurst && <div className="media-burst" aria-hidden="true">★</div>}
      </div>

      {/* EYLEM ŞERİDİ — ORTAK SUNUM BİLEŞENİ (2026-09-13, owner ortaklaştırma).
          Sıra, hücreler ve ikon ölçüsü artık `PostActionsBar`da; bu ekran yalnız
          İŞLEYİCİLERİ veriyor. Eskiden aynı dört eylem burada 24 px, profil
          görüntüleyicisinde 28 px'ti — iki bağımsız karar kaynağı. */}
      <PostActionsBar
        onek="pm"
        sayiBicimle={formatCount}
        yildiz={
          /* Yıldız tetiği yüzeye özgü kalır (contentId/authorId/disabled).
             BUG FIX (2026-06-30): prop `onRated` — `onRate` yazımında puan
             Firestore'a hiç yazılmıyordu. #931: kendi gönderinde tetik
             `aria-disabled` + sebep BASINCA duyurulur (kalıcı satır YOK). */
          <StarRatingV2
            className="pm-btn"
            size={24}
            contentId={post?.id}
            authorId={post?.authorId}
            type={post?.type || "post"}
            onRated={handleRate}
            openNonce={rateOpenNonce}
            disabled={isOwner}
            disabledReason="Kendi gönderine puan veremezsin"
          />
        }
        onYorum={() => onCommentClick?.(post)}
        yorumAdet={yorumAdet}
        eskiYorum={<CommentIcon size={24} weight="regular" />}
        onPaylas={handleShare}
        paylasAdet={paylasAdet}
        eskiPaylas={<ShareIcon size={24} weight="regular" />}
        onKaydet={handleToggleSave}
        kaydedildi={isSaved}
        eskiKaydet={<SaveIcon size={24} active={isSaved} weight="regular" />}
      />

      <div className="pm-footer">
        {/* ══ GÖNDERİ ÖZET SATIRI (`.pm-meta`) — bu turda kuruldu ═══════════
            Owner (§8): *"Bunların hangisinin sürekli görünmesi, hangisinin
            değerlendirme panelinde veya ihtiyaç anında açıklanması gerektiğini
            düzenle … Önemli bilgi silinmesin; uygun hiyerarşiye taşınsın."*

            ÜÇ BİLGİ AYNI KATMANDA: ikisi de "bu gönderi hakkında özet",
            üçüncüsü onların NİYE eksik olduğunun açıklaması. Üçü de eylem
            DEĞİL → eylem şeridinde işleri yok, tek bir özet satırındalar.
            Satır SARAR (`flex-wrap`), taşmaz; hiçbiri kendi tam-genişlik
            satırını AÇMAZ (öz-puanlama notu eskiden açıyordu).

            AYRIM (owner: *"Kullanıcının verdiği puan, ortalama puanla
            karışmasın"*) — üç BAĞIMSIZ sinyalle:
              1. sözcük:  "Ortalama …"  ↔  "Puanın: …"
              2. biçim:   düz metin      ↔  kenarlıklı hap (`.pm-meta-mine`)
              3. ağırlık: normal/muted   ↔  600 / tam kontrast ön plan
            Eskiden ikisi de `.pm-num.pm-starmeta` idi: AYNI sınıf, AYNI
            ağırlık, AYNI renk, yan yana — ölçüldü (ÖNCE karesi). */}
        {/* PUAN ÖZETİ — ORTAK BİLEŞEN (owner, 2026-09-14: *"Puan özeti ortak
            bileşen değil… aynı konumda bulunmaları ortaklaştırmanın
            tamamlandığı anlamına gelmiyor."*). Sözcük/biçim/sıra kararı
            `PostRatingSummary`de; bu ekran yalnız VERİYİ veriyor. */}
        <PostRatingSummary
          onek="pm"
          ortalama={agg && agg.avg > 0 && agg.count > 0 ? { avg: Number(agg.avg), count: Number(agg.count) } : null}
          benimPuanim={myCachedRating}
          kendiIcerigi={isOwner}
          sayiBicimle={formatCount}
        />
        {/* Masaüstü-mobil parite fix (2026-06-30) — bu rozet Post.tsx'te
            (desktop) vardı ama mobilde hiç yoktu: yorumlar sahibi tarafından
            kapatılmışsa mobil kullanıcı SEBEBİ görmeden yorum yapamıyordu. */}
        {post?.yorumlarKapali && <div className="comments-locked">Yorumlar kapalı</div>}
        {/* KAMPANYA — esnaf postu: fiyat şeridi */}
        {post?.postType === 'kampanya' && post?.price?.amount > 0 && (
          <div className={`post-kampanya ${post?.validUntil?.toMillis && post.validUntil.toMillis() < Date.now() ? 'is-expired' : ''}`}>
            <span className="post-kampanya__badge">
              {post?.validUntil?.toMillis && post.validUntil.toMillis() < Date.now() ? 'KAMPANYA SONA ERDİ' : 'KAMPANYA'}
            </span>
            {post?.price?.oldAmount > 0 && (
              <s className="post-kampanya__old">{(post.price.oldAmount / 100).toLocaleString('tr-TR')} TL</s>
            )}
            <strong className="post-kampanya__new">{(post.price.amount / 100).toLocaleString('tr-TR')} TL</strong>
          </div>
        )}
        {editOpen ? (
          <div className="pm-captionEdit">
            <textarea
              value={editText}
              maxLength={2200}
              onChange={(e) => setEditText(e.target.value)}
              aria-label="Açıklamayı düzenle"
            />
            <div className="pm-captionEditBtns">
              <button type="button" className="save pressable" onClick={saveEdit}>Kaydet</button>
              <button className="pressable" type="button" onClick={cancelEdit}>İptal</button>
            </div>
          </div>
        ) : captionText && (
          <p className="pm-caption">
            <strong className="pm-cap-user" onClick={() => onUserClick?.(post.authorId)}>{username}</strong>{" "}
            <span><RichCaption text={showFullCaption ? captionText : captionPreview} /></span>
            {needsClamp && !showFullCaption && (
              <>
                <span>… </span>
                <button
                  className="pm-moreBtn pressable"
                  onClick={() => setShowFullCaption(true)}
                  aria-label="Devamını göster"
                >
                  devamı
                </button>
              </>
            )}
          </p>
        )}
        {/* P1-1 — "Tüm N yorumu gör" (IG). Masaüstünde `.postDk-commentsLink`
            olarak zaten vardı; mobilde HİÇ YOKTU → kullanıcı yorumların
            SAYISINI yalnız ikon şeridindeki çıplak rakamdan çıkarabiliyordu ve
            yorum panelini açan ikinci bir metin girişi yoktu. Koşul masaüstüyle
            aynı kaynaktan (`yorumAdet`) türer; sıfırsa satır basılmaz. */}
        {yorumAdet > 0 && (
          <button className="pm-commentsLink pressable" onClick={() => onCommentClick?.(post)}>
            Tüm {formatCount(yorumAdet)} yorumu gör
          </button>
        )}
        <time
          className="pm-time"
          dateTime={damgaAttr(post?.tarih)}
          title={baslikAttr(post?.tarih)}
        >
          {formatTimeAgoShort(post?.tarih)}
          {post?.duzenlendiAt && <span className="pm-edited"> · düzenlendi</span>}
        </time>
      </div>
      {/* 🔴 EKSİKTİ (ölçüldü 2026-08-24): gönderiler ŞİKAYET EDİLEMİYORDU.
          Şikayet hattının TAMAMI hazırdı (callable + rate-limit + self-report
          guard + admin ekranı) ama `REPORT_TARGET_TYPE` gönderiyi tanımıyordu
          ve menüde satır yoktu → moderasyonun tek kullanıcı-tetikli girişi
          gönderiler için KAPALIYDI. IG paritesi: her gönderinin şikayet yolu
          vardır. Kendi gönderisi için gösterilmez (sunucu da reddeder). */}
      <ReportModal
        open={!!sikayetHedefi}
        target={sikayetHedefi}
        onClose={() => setSikayetHedefi(null)}
      />
      {/* P1-4/P1-5 — kart ✈️ artık `window.alert` açmıyor; detayla AYNI
          paylaş sheet'ini açıyor (DM'e gönder + bağlantıyı kopyala + sistem).
          🔗 URL YOK (kasıtlı, IG'de de yok) — geri tuşu sheet'i kapatır. */}
      <ShareSheet
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        permalink={permalink}
        attachment={shareAttachment}
      />
    </article>
  );
}


